import Card from '../../../components/commoncomponents/Card';

function AccessLockedState({ businessName }) {
  return (
    <Card className="px-6 py-8 sm:px-8">
      <h2 className="m-0 text-2xl font-semibold tracking-[-0.03em] text-[#111111]">
        Business access not open yet
      </h2>
      <p className="mt-3 max-w-2xl text-sm leading-6 text-[#8b7a6d]">
        {businessName || 'This business'} is visible in the portal, but user management will stay locked until the
        business is marked as active and its portal access is set to open.
      </p>
    </Card>
  );
}

export default AccessLockedState;
